import { Component, ChangeDetectionStrategy } from "@angular/core";
declare const BrandVars;

@Component({
	selector: "app-footer",
	templateUrl: "./footer.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ["./footer.component.scss"]
})
export class FooterComponent {
	public brand = BrandVars;
	public year = new Date().getFullYear();

}
